import React, {Component} from "react";
import arrowRight from "../../source/image/common/ic_chevron_right.png";
import {BridgeHelper} from "../../utils/bridgeHelper";
import {GetH5ContainerURL, H5RouteName, RouteName} from "../../common/routeName";
import {Color} from "../../common/styles";
import {languagePackage} from "../../common/language";


export const FeedbackTypes = [
    languagePackage().GeneralFeedback,
    languagePackage().IncorrectProviderInformation,
    languagePackage().ScheduleAnAppointment,
    languagePackage().FindDoctor,
    languagePackage().OtherQuestions
];

export default class FeedbackSelection extends Component {

    onClick(val, idx) {
        let passProps = {
            url: GetH5ContainerURL(H5RouteName.feedback.edit),
            passProps: {feedbackType: val},
            style: {backgroundColor: Color.white}
        };
        BridgeHelper.pushPage(RouteName.bridgeWebView, languagePackage().Feedback, passProps);
    }

    renderItem(val, idx) {
        return (
            <div
                key={idx}
                className={'flex justify-between py-4 mx-5 border-b border-lightGray bg-white'}
                onClick={() => {
                    this.onClick(val, idx)
                }}
            >
                <div className={'font-semibold text-base text-primary'}>{val}</div>
                <img className={'w-6 h-6'} src={arrowRight} alt={""}/>
            </div>
        )
    }

    render() {
        return (
            <div className={'w-screen h-screen bg-white'}>
                {
                    FeedbackTypes.map((val, idx) => this.renderItem(val, idx))
                }
            </div>
        )
    }
}
